module.exports = __webpack_public_path__ + "fonts/iconfont.b243c07.ttf";